import { useState } from "react";
import {
  ToolbarButton,
  Body1Strong,
  Body1Stronger,
  Dialog,
  DialogSurface,
  DialogTitle,
  DialogBody,
  DialogActions,
  DialogTrigger,
  Button,
  DialogContent,
  mergeClasses
} from "@fluentui/react-components";
import { useGlobalStatus } from "../../services/GlobalStatusProvider";
import { addDays, format } from "date-fns";
import { formatDisplayDate } from "../../services/TimeFunctions";

export default function MobileDayTotals({ timesheetData }) {
  const [open, setOpen] = useState(false);
  const { currentWeekStart, useStyles, dateToggle }= useGlobalStatus();
  const styles = useStyles();

  const dates = Array.from({ length: 7 }, (_, i) => addDays(currentWeekStart, i));

  const dailyTotals = dates.map((date) => {
    let totalMinutes = 0;
    timesheetData.forEach((client) => {
      client.projects.forEach((project) => {
        project.budgets.forEach((budget) => {
          budget.timecodes.forEach((timecode) => {
            timecode.entryDays.forEach((entry) => {
              if (
                entry.date.toString() === date.toString() &&
                entry.status !== "empty" &&
                entry.status !== "error"
              ) {
                totalMinutes += entry.entries.reduce((sum, e) => sum + e.totalMinutes, 0);
              }
            });
          });
        });
      });
    });
    return Math.round((totalMinutes / 60));
  });

  const weekTotal = dailyTotals.reduce((sum, dayTotal) => sum + dayTotal, 0);

  return (
    <Dialog open={open} onOpenChange={(e, { open }) => setOpen(open)}>
      <DialogTrigger>
        <ToolbarButton 
        className={styles.buttonPrimary}
        >
          Day Totals
        </ToolbarButton>
      </DialogTrigger>

      <DialogSurface>
        <DialogBody>
          <DialogTitle>Day Totals: <strong>{format(dates[0], "do MMM")} - {format(dates[6], "do MMM")}</strong></DialogTitle>
          <DialogContent>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
                gap: "8px",
              }}>
              {dailyTotals.map((total, index) => (
                <div key={index}
                className={mergeClasses(styles.mobileDayTotals)}>
                  <Body1Strong>{format(dates[index], "eeee do")}</Body1Strong>
                  <Body1Stronger>{formatDisplayDate(total, dateToggle, true)} </Body1Stronger>
                </div>
              ))}
              <div className={mergeClasses(styles.mobileDayTotals)}>
                  <Body1Strong>Week Total</Body1Strong>
                  <Body1Stronger>{formatDisplayDate(weekTotal, dateToggle, true)}</Body1Stronger>
                </div>
            </div>
          </DialogContent>

          <DialogActions>
            <Button appearance="secondary" onClick={() => setOpen(false)}>
              Close
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}
